/*
 * Copyright (C) 2019 Robert Bosch GmbH Copyright (C) 2019 Robert Bosch Manufacturing Solutions GmbH, Germany. All rights reserved.
 */

export enum LogLevel {
  TRACE = 0,
  DEBUG = 1,
  INFORMATION = 2,
  WARN = 3,
  ERROR = 4,
  CRITICAL = 5,
  NONE = 6
}

export type LogLevelStrings = keyof typeof LogLevel;
